module.exports = __webpack_public_path__ + "static/media/shape_logo.217f5c58.svg";